import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { CancelReservationResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

/**
 * bypasses authorization and cancels the reservation request. also marks the cancellation category as ADMIN_CANCELLED.
 * @returns
 */
export const useAdminCancelReservation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (reservationId: number): Promise<CancelReservationResponseDto> => {
      const response = await apiFetch(`api/admin/reservations/${reservationId}/cancel`, {
        method: "POST",
      });
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
    // Returning the promise keeps the mutation pending until the refetch finishes.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["events"] }),
        queryClient.invalidateQueries({ queryKey: ["reservation-requests", "admin"] }),
      ]),
  });
};
